import validate from 'validate.js'

const constraints = {
  items: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
